import { render, staticRenderFns } from "./TeamResources.vue?vue&type=template&id=7e1480fa&"
import script from "./TeamResources.vue?vue&type=script&lang=js&"
export * from "./TeamResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports